export const state = {
  showSpinner: true
};



// WEBPACK FOOTER //
// ./src/store/state.js